import { createTheme, ThemeOptions } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#f5f5f5",
    },
    secondary: {
      main: "#001aaf",
    },
    error: {
      main: "#ef483a",
    },
    warning: {
      main: "#ff9600",
    },
    info: {
      main: "#2196f7",
    },
    success: {
      main: "#42bd46",
    },
    divider: "rgba(0,0,0,0.12)",
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: "2.5rem",
      fontWeight: 300,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 300,
      lineHeight: 1.2,
    },
  },
};

const defaultTheme = createTheme(themeOptions);
export default defaultTheme;
